/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 42);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Ajax request class
 */
var EpsilonAjaxRequest = /** @class */ (function () {
    /**
     * Constructor
     * @param {Object} args
     */
    function EpsilonAjaxRequest(args) {
        this.args = args;
    }
    /**
     * Init Request
     */
    EpsilonAjaxRequest.prototype.request = function () {
        var self = this;
        jQuery.ajax({
            type: 'POST',
            data: { action: 'epsilon_framework_ajax_action', args: self.args },
            dataType: 'json',
            url: EpsilonWPUrls.ajaxurl,
            success: function (data) {
                self.result = data;
                jQuery(self).trigger('epsilon-received-success');
            },
            /**
             * Throw errors
             *
             * @param jqXHR
             * @param textStatus
             * @param errorThrown
             */
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
            }
        });
    };
    return EpsilonAjaxRequest;
}());
exports.EpsilonAjaxRequest = EpsilonAjaxRequest;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Range Slider Module
 */
var EpsilonRangeSlider = /** @class */ (function () {
    /**
     * Class constructor
     * @param {{container: JQuery; params: {value: number; id: string; sliderControls: {min: number; max: number; step: number}}}} control
     */
    function EpsilonRangeSlider(control) {
        /**
         * Minimum
         * @type {number}
         */
        this.min = 1;
        /**
         * Maximum
         * @type {number}
         */
        this.max = 20;
        /**
         * Step incrementor
         * @type {number}
         */
        this.step = 1;
        this.context = jQuery(control.container).hasClass('slider-container') ? jQuery(control.container) : jQuery(control.container).find('.slider-container');
        this.min = control.params.sliderControls.min;
        this.max = control.params.sliderControls.max;
        this.step = control.params.sliderControls.step;
        this.value = control.params.value;
        if (!this.context) {
            return;
        }
        this.init();
    }
    /**
     * Initiator
     */
    EpsilonRangeSlider.prototype.init = function () {
        var self = this;
        var slider = this.context.find('.ss-slider'), input = this.context.find('.rl-slider'), inputId = input.attr('id'), id = slider.attr('id');
        jQuery('#' + id).slider({
            value: this.value,
            range: 'min',
            min: this.min,
            max: this.max,
            step: this.step,
            /**
             * Removed Change event because server was flooded with requests from
             * javascript, sending changesets on each increment.
             *
             * @param event
             * @param ui
             */
            slide: function (event, ui) {
                jQuery('#' + inputId).attr('value', ui.value);
            },
            /**
             * Bind the change event to the "actual" stop
             * @param event
             * @param ui
             */
            stop: function (event, ui) {
                jQuery('#' + inputId).trigger('change');
            }
        });
        jQuery(input).on('focus', function () {
            jQuery(this).blur();
        });
        jQuery('#' + inputId).attr('value', (jQuery('#' + id).slider('value')));
    };
    return EpsilonRangeSlider;
}());
exports.EpsilonRangeSlider = EpsilonRangeSlider;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Text Editor Module
 */
var EpsilonTextEditor = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; params: {value: number; id: string}}} control
     */
    function EpsilonTextEditor(control, repeater, deconstruct) {
        if (repeater === void 0) { repeater = false; }
        if (deconstruct === void 0) { deconstruct = false; }
        this.context = jQuery(control.container);
        this.editorId = control.params.id + '-editor';
        if (repeater) {
            this.editorId = control.params.id;
        }
        if (deconstruct) {
            wp.editor.remove(this.editorId);
        }
        this.init();
    }
    /**
     * Text editor initiator
     */
    EpsilonTextEditor.prototype.init = function () {
        wp.editor.initialize(this.editorId, {
            tinymce: {
                wpautop: true,
                setup: function (editor) {
                    editor.on('change', function (e) {
                        editor.save();
                        jQuery(editor.getElement()).trigger('change');
                    });
                }
            },
            quicktags: true
        });
    };
    return EpsilonTextEditor;
}());
exports.EpsilonTextEditor = EpsilonTextEditor;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Button Group
 */
var EpsilonButtonGroup = /** @class */ (function () {
    /**
     * Class constructor
     * @param {{container: JQuery; setting: void; params: {value: number; id: string}}} control
     */
    function EpsilonButtonGroup(control) {
        this.control = control;
        this.context = control.container;
        this.handleEvents();
    }
    /**
     * Handle click events
     */
    EpsilonButtonGroup.prototype.handleEvents = function () {
        var self = this;
        this.context.on('click', '.epsilon-control-group > a', function (e) {
            e.preventDefault();
            var value = jQuery(this).attr('data-value');
            jQuery(this).siblings().removeClass('active');
            jQuery(this).addClass('active');
            if (!self.control.hasOwnProperty('repeater')) {
                self.control.setting.set(jQuery(this).attr('data-value'));
            }
            else {
                jQuery(this).parent().find('input').val(value).trigger('change');
            }
        });
    };
    return EpsilonButtonGroup;
}());
exports.EpsilonButtonGroup = EpsilonButtonGroup;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Color Picker Module
 */
var EpsilonColorPicker = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; setting: void; params: {value: number; id: string}}} control
     */
    function EpsilonColorPicker(control) {
        var self = this;
        var clear;
        this.control = control;
        this.context = jQuery(control.container).find('.epsilon-color-picker');
        this.settings = {
            changeDelay: 500,
            theme: 'default',
            change: this.changePallete,
        };
        if ('function' !== typeof jQuery.fn.minicolors) {
            return;
        }
        if ('' !== this.context.attr('placeholder')) {
            this.context.defaultValue = this.context.attr('placeholder');
        }
        if ('rgba' === this.context.attr('data-attr-mode')) {
            this.context.format = 'rgb';
            this.context.opacity = true;
        }
        this.context.minicolors(this.settings);
        clear = this.context.parents('.customize-control-epsilon-color-picker').find('a');
        if (!clear.length) {
            clear = this.context.parents('.repeater-field-epsilon-color-picker').find('a');
        }
        clear.on('click', function (e) {
            e.preventDefault();
            self.instance = jQuery(this).parents('.customize-control-epsilon-color-picker').find('input.epsilon-color-picker');
            if (!self.instance.length) {
                self.instance = jQuery(this).parents('.repeater-field-epsilon-color-picker').find('input.epsilon-color-picker');
            }
            self.instance.minicolors('value', jQuery(this).attr('data-default'));
            self.instance.trigger('change');
        });
    }
    /**
     * Real time changes to the "pallete"
     *
     * @param value
     * @param opacity
     */
    EpsilonColorPicker.prototype.changePallete = function (value, opacity) {
        jQuery('.epsilon-color-scheme-selected').find('*[data-field-id="' + jQuery(this).attr('data-customize-setting-link') + '"]').css('background-color', value);
    };
    return EpsilonColorPicker;
}());
exports.EpsilonColorPicker = EpsilonColorPicker;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Customizer Navigation Module
 */
var EpsilonCustomizerNavigation = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; params: {value: number; id: string}}} control
     */
    function EpsilonCustomizerNavigation(control) {
        this.context = jQuery(control.container);
        this.multiple = this.context.find('.epsilon-customizer-navigation-container').length > 1;
        if (this.multiple) {
            this.initMultiple();
        }
        else {
            this.init();
        }
    }
    /**
     * Init multiple fields
     */
    EpsilonCustomizerNavigation.prototype.initMultiple = function () {
        var containers = this.context.find('.epsilon-customizer-navigation-container:not(.initiated)').first().addClass('initiated');
        containers.map(function (index, element) {
            jQuery(element).find('a').on('click', function (e) {
                e.preventDefault();
                if ('undefined' !== typeof (wp.customize.section(jQuery(this).attr('data-customizer-section')))) {
                    if (jQuery(e.target).attr('data-doubled')) {
                        wp.customize.section(jQuery(this).attr('data-customizer-section')).headContainer.trigger('click');
                    }
                    else {
                        wp.customize.section(jQuery(this).attr('data-customizer-section')).focus();
                    }
                }
            });
        });
    };
    /**
     * Control initiator
     */
    EpsilonCustomizerNavigation.prototype.init = function () {
        var navigation = this.context.find('.epsilon-customizer-navigation-container');
        if (navigation.length) {
            navigation.on('click', navigation.find('a'), function (e) {
                e.preventDefault();
                if ('undefined' !== typeof (wp.customize.section(jQuery(e.target).attr('data-customizer-section')))) {
                    if (jQuery(e.target).attr('data-doubled')) {
                        wp.customize.section(jQuery(e.target).attr('data-customizer-section')).headContainer.trigger('click');
                    }
                    else {
                        wp.customize.section(jQuery(e.target).attr('data-customizer-section')).focus();
                    }
                }
            });
        }
    };
    return EpsilonCustomizerNavigation;
}());
exports.EpsilonCustomizerNavigation = EpsilonCustomizerNavigation;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var repeater_addons_1 = __webpack_require__(7);
var repeater_utils_1 = __webpack_require__(9);
var EpsilonFieldRepeater = /** @class */ (function () {
    /**
     * Object constructor
     * @param control
     */
    function EpsilonFieldRepeater(control) {
        /**
         * Rows
         * @type {Array}
         */
        this.rows = [];
        /**
         * Current index
         */
        this.currentIndex = 0;
        this.control = control;
        this.context = control.container;
        this.utils = this.loadUtils();
        this.template = this.loadTemplate();
        /**
         * Create a reference of the container
         */
        this.repeaterContainer = this.getRepeaterContainer();
        /**
         * Setting field reference
         */
        this.settingField = this.context.find('[data-customize-setting-link]');
        /**
         * Setup Limit
         *
         * @type {boolean}
         */
        if (!_.isUndefined(this.control.params.choices.limit)) {
            this.limit = (0 >= this.control.params.choices.limit) ? false : parseInt(this.control.params.choices.limit);
        }
        /**
         * Handle events
         */
        this.handleEvents();
        /**
         * Create the existing rows
         */
        this.createExistingRows();
        /**
         * Make rows sortable
         */
        this.initSortable();
    }
    /**
     * Repeater container
     * @returns {any}
     */
    EpsilonFieldRepeater.prototype.getRepeaterContainer = function () {
        return this.context.find('.repeater-fields');
    };
    /**
     * Load utilities
     * @public
     */
    EpsilonFieldRepeater.prototype.loadUtils = function () {
        return new repeater_utils_1.EpsilonRepeaterUtils(this);
    };
    /**
     * Load template
     */
    EpsilonFieldRepeater.prototype.loadTemplate = function () {
        return this.utils.repeaterTemplate();
    };
    /**
     * Create existing rows
     */
    EpsilonFieldRepeater.prototype.createExistingRows = function () {
        var control = this;
        if (this.control.params.value.length) {
            for (var i = 0; i < this.control.params.value.length; i++) {
                var row = void 0, addons = void 0;
                row = control.utils.add(this.control.params.value[i]);
                addons = new repeater_addons_1.EpsilonRepeaterAddons(control, row);
                addons.initPlugins();
            }
        }
    };
    /**
     * Handle click/saving/etc events
     */
    EpsilonFieldRepeater.prototype.handleEvents = function () {
        var self = this;
        /**
         * 1. Add row button
         */
        this.context.on('click', 'button.epsilon-repeater-add', function (e) {
            var newRow, addons;
            e.preventDefault();
            if (!self.limit || self.currentIndex < self.limit) {
                newRow = self.utils.add();
                addons = new repeater_addons_1.EpsilonRepeaterAddons(self, newRow);
                addons.initPlugins();
            }
            else {
                jQuery(self.control.selector + ' .limit').addClass('highlight');
            }
        });
        /**
         * 2. REMOVE Row button
         */
        this.context.on('click', '.repeater-row-remove', function (e) {
            self.handleRowDecrementor();
            if (!self.limit || self.currentIndex < self.limit) {
                jQuery(self.control.selector + ' .limit').removeClass('highlight');
            }
        });
    };
    /**
     * Initiate sortable functionality
     */
    EpsilonFieldRepeater.prototype.initSortable = function () {
        var control = this;
        this.repeaterContainer.sortable({
            handle: '.repeater-row-header',
            axis: 'y',
            distance: 15,
            stop: function (e, data) {
                setTimeout(control.utils.sort(data), 200);
            },
        });
    };
    /**
     * Handles row addition
     */
    EpsilonFieldRepeater.prototype.handleRowIncrementor = function () {
        /**
         * Update index;
         */
        this.currentIndex++;
    };
    /**
     * Handles row addition
     */
    EpsilonFieldRepeater.prototype.handleRowDecrementor = function () {
        /**
         * Update index;
         */
        this.currentIndex--;
    };
    return EpsilonFieldRepeater;
}());
exports.EpsilonFieldRepeater = EpsilonFieldRepeater;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = __webpack_require__(0);
var button_group_1 = __webpack_require__(3);
var range_slider_1 = __webpack_require__(1);
var text_editor_1 = __webpack_require__(2);
var color_picker_1 = __webpack_require__(4);
var customizer_navigation_1 = __webpack_require__(5);
var EpsilonRepeaterAddons = /** @class */ (function () {
    /**
     *
     * @param {EpsilonFieldRepeater | EpsilonSectionRepeater} control
     * @param {EpsilonRepeaterSectionRow | EpsilonRepeaterRow | any} row
     */
    function EpsilonRepeaterAddons(control, row) {
        this.control = control;
        this.row = row;
        this.proxy = this.control.control.params;
        if (this.row.hasOwnProperty('type')) {
            this.proxy = this.proxy.sections[this.row.type];
        }
    }
    /**
     * Init all plugins
     */
    EpsilonRepeaterAddons.prototype.initPlugins = function () {
        this.initRangeSliders();
        this.initImageUploads();
        this.initIconPicker();
        this.initTextEditor();
        this.initColorPickers();
        this.initButtonGroup();
        if (this.row.hasOwnProperty('type')) {
            this.initCustomizerNavigation();
            this.initSelectize();
        }
    };
    /**
     * Initiate button group
     */
    EpsilonRepeaterAddons.prototype.initButtonGroup = function () {
        var self = this;
        var settings = {
            container: self.row.container,
            repeater: true,
        };
        new button_group_1.EpsilonButtonGroup(settings);
    };
    /**
     * Selectize inputs
     */
    EpsilonRepeaterAddons.prototype.initSelectize = function () {
        this.row.container.find('.epsilon-selectize').selectize({
            plugins: ['remove_button'],
        });
    };
    /**
     * Init navigation between sections
     */
    EpsilonRepeaterAddons.prototype.initCustomizerNavigation = function () {
        var self = this;
        var init = false, settings;
        for (var k in self.proxy.fields) {
            if ('epsilon-customizer-navigation' === self.proxy.fields[k].type) {
                settings = self.row;
                new customizer_navigation_1.EpsilonCustomizerNavigation(settings);
            }
        }
    };
    /**
     * Init color pickers
     */
    EpsilonRepeaterAddons.prototype.initColorPickers = function () {
        var self = this;
        var init = false, settings;
        settings = self.row;
        new color_picker_1.EpsilonColorPicker(settings);
    };
    /**
     * Handle image uploads
     */
    EpsilonRepeaterAddons.prototype.initImageUploads = function () {
        var self = this;
        var temp;
        /**
         * Image controls - Upload
         */
        self.row.container.on('click keypress', '.epsilon-controller-image-container .image-upload-button', function (e) {
            e.preventDefault();
            if (wp.customize.utils.isKeydownButNotEnterEvent(e)) {
                return;
            }
            temp = jQuery(this).parents('.epsilon-controller-image-container');
            self._imageUpload(temp);
        });
        /**
         * Image Controls - Removal
         */
        self.row.container.on('click keypress', '.epsilon-controller-image-container .image-upload-remove-button', function (e) {
            e.preventDefault();
            if (wp.customize.utils.isKeydownButNotEnterEvent(e)) {
                return;
            }
            temp = jQuery(this).parents('.epsilon-controller-image-container');
            self._imageRemoval(temp);
        });
    };
    /**
     * Image Upload
     * @private
     */
    EpsilonRepeaterAddons.prototype._imageUpload = function (container) {
        var self = this;
        var setting = {}, temp, size, val, input, image = wp.media({
            multiple: false,
        }).open();
        /**
         * On selection, save the data in a JSON
         */
        image.on('select', function () {
            input = container.find('input');
            temp = image.state().get('selection').first();
            size = input.attr('data-size');
            if ('undefined' === typeof (temp.toJSON().sizes[size])) {
                size = 'full';
            }
            setting.id = temp.id;
            setting.url = temp.toJSON().sizes[size].url;
            val = ('url' === input.attr('data-save-mode')) ? setting.url : setting.id;
            input.val(val);
            self._setImage(container, setting.url);
            container.find('.actions .image-upload-remove-button').show();
        });
    };
    /**
     * Removes image
     * @private
     */
    EpsilonRepeaterAddons.prototype._imageRemoval = function (container) {
        var self = this;
        var thumb = container.find('.epsilon-image');
        if (thumb.length) {
            thumb.find('img').fadeOut(200, function () {
                var html = EpsilonTranslations.selectFile + '<span class="recommended-size"></span>', Ajax, data = {
                    action: ['Epsilon_Helper', 'get_image_sizes'],
                    nonce: EpsilonWPUrls.ajax_nonce,
                    args: [],
                }, size = container.find('input').attr('data-size');
                thumb.removeClass('epsilon-image').addClass('placeholder').html(html);
                Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(data);
                Ajax.request();
                jQuery(Ajax).on('epsilon-received-success', function (e) {
                    if (!_.isUndefined(Ajax.result[size])) {
                        thumb.find('.recommended-size').text(Ajax.result[size].width + ' x ' + Ajax.result[size].height);
                    }
                });
            });
        }
        container.find('.actions .image-upload-remove-button').hide();
        container.find('input').attr('value', '').trigger('change');
    };
    /**
     * Sets the uploaded image
     * @private
     */
    EpsilonRepeaterAddons.prototype._setImage = function (container, url) {
        /**
         * If we already have an image, we need to return that div, else we grab the placeholder
         *
         * @type {*}
         */
        var thumb = container.find('.epsilon-image').length ? container.find('.epsilon-image') : container.find('.placeholder');
        /**
         * We "reload" the image container
         */
        if (thumb.length) {
            thumb.removeClass('epsilon-image placeholder').addClass('epsilon-image');
            thumb.html('');
            thumb.append('<img style="display:none" src="' + url + '" />');
            thumb.find('img').fadeIn(200);
        }
        container.find('input').trigger('change');
    };
    /**
     * Icon picker
     */
    EpsilonRepeaterAddons.prototype.initIconPicker = function () {
        var self = this;
        var init = false, temp;
        for (var k in self.proxy.fields) {
            if ('epsilon-icon-picker' === self.proxy.fields[k].type) {
                init = true;
                /***
                 * Toggle
                 */
                self.row.container.on('click keypress', '.epsilon-icon-picker-repeater-container .epsilon-icon-container', function (e) {
                    e.preventDefault();
                    if (wp.customize.utils.isKeydownButNotEnterEvent(e)) {
                        return;
                    }
                    jQuery(this).toggleClass('opened-icon-picker');
                    temp = jQuery(this).parents('.epsilon-icon-picker-repeater-container');
                    self._iconPickerToggle(temp);
                });
                /**
                 * Selection
                 */
                self.row.container.on('click keypress', '.epsilon-icon-picker-repeater-container .epsilon-icons-container .epsilon-icons > i', function (e) {
                    e.preventDefault();
                    if (wp.customize.utils.isKeydownButNotEnterEvent(e)) {
                        return;
                    }
                    temp = jQuery(this).parents('.epsilon-icon-picker-repeater-container');
                    self._iconPickerSelection(this, temp);
                });
                /**
                 * Filtering
                 */
                self.row.container.on('keyup change', '.epsilon-icon-picker-repeater-container .search-container input', _.debounce(function (e) {
                    e.preventDefault();
                    if (wp.customize.utils.isKeydownButNotEnterEvent(e)) {
                        return;
                    }
                    temp = jQuery(this).parents('.epsilon-icon-picker-repeater-container');
                    self._iconPickerFilter(this, temp);
                }, 1000));
            }
        }
    };
    /**
     * Toggle the icon picker dropdown
     * @private
     */
    EpsilonRepeaterAddons.prototype._iconPickerToggle = function (container) {
        container.find('.epsilon-icon-picker-container').toggleClass('opened');
    };
    /**
     * Icon pick
     * @private
     */
    EpsilonRepeaterAddons.prototype._iconPickerSelection = function (clicked, container) {
        var icon, label;
        container.find('.epsilon-icons > i.selected').removeClass('selected');
        icon = jQuery(clicked).addClass('selected').attr('data-icon');
        label = jQuery(clicked).attr('data-search');
        container.find('.epsilon-icon-name > i').removeClass().addClass(icon);
        container.find('.epsilon-icon-name > .icon-label').html(label);
        /**
         * Set value
         */
        container.find('.epsilon-icon-picker').attr('value', icon).trigger('change');
    };
    /**
     * Icon picker filtering
     * @private
     */
    EpsilonRepeaterAddons.prototype._iconPickerFilter = function (input, container) {
        var filter, temp, collection = jQuery(container).find('.epsilon-icons > i');
        filter = jQuery(input).val();
        if ('undefined' !== typeof filter) {
            filter = filter.toLowerCase();
        }
        jQuery.each(collection, function () {
            temp = jQuery(this).attr('data-search');
            if ('undefined' !== typeof temp) {
                temp = temp.toLowerCase();
            }
            jQuery(this)[temp.indexOf(filter) !== -1 ? 'show' : 'hide']();
        });
    };
    /**
     * WP Texteditor
     */
    EpsilonRepeaterAddons.prototype.initTextEditor = function () {
        var self = this;
        var textareas = jQuery(self.row.container).find('textarea');
        var _loop_1 = function (i) {
            setTimeout(function () {
                var settings = {
                    container: jQuery(textareas[i]).parent(),
                    params: {
                        id: jQuery(textareas[i]).attr('id')
                    }
                };
                new text_editor_1.EpsilonTextEditor(settings, true);
            }, 100 * i);
        };
        for (var i = 0; i < textareas.length; i++) {
            _loop_1(i);
        }
    };
    /**
     * initiate range sliders
     */
    EpsilonRepeaterAddons.prototype.initRangeSliders = function () {
        var self = this;
        var init = false, sliderSettings, val;
        for (var k in self.proxy.fields) {
            if ('epsilon-slider' === self.proxy.fields[k].type) {
                init = true;
                sliderSettings = {
                    container: self.row.container,
                    params: {
                        id: self.proxy.fields[k].id,
                        sliderControls: {
                            min: self.proxy.fields[k].choices.min,
                            max: self.proxy.fields[k].choices.max,
                            step: self.proxy.fields[k].choices.step
                        }
                    }
                };
                if (self.row.hasOwnProperty('type')) {
                    sliderSettings.params.value = parseFloat(self.proxy.fields[k].default);
                    if ('undefined' !== typeof self.control.control.params.value[self.row.index]) {
                        sliderSettings.params.value = parseFloat(self.control.control.params.value[self.row.index][k]);
                    }
                    new range_slider_1.EpsilonRangeSlider(sliderSettings);
                    return;
                }
                if ('undefined' !== typeof self.proxy.value[self.row.index]) {
                    sliderSettings.params.value = parseFloat(self.proxy.value[self.row.index][k]);
                }
                sliderSettings.container = jQuery(sliderSettings.container).find('.epsilon-slider:not(.initiated)').first().addClass('initiated');
                new range_slider_1.EpsilonRangeSlider(sliderSettings);
            }
        }
    };
    return EpsilonRepeaterAddons;
}());
exports.EpsilonRepeaterAddons = EpsilonRepeaterAddons;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EpsilonRepeaterRow = /** @class */ (function () {
    /**
     * Row Constructor
     * @param {{container: JQuery; setting: void; params: {value: number; id: string}}} instance
     * @param {JQuery} rowContainer
     */
    function EpsilonRepeaterRow(instance, rowContainer) {
        var self = this;
        this.index = instance.currentIndex;
        this.container = rowContainer;
        this.label = this.getLabel(instance);
        this.header = this.container.find('.repeater-row-header');
        this.footer = this.container.find('.repeater-row-footer');
        this.handleEvents(instance);
        instance.utils.updateLabel(this);
    }
    /**
     *
     * @returns {any}
     */
    EpsilonRepeaterRow.prototype.getLabel = function (instance) {
        return instance.control.params.rowLabel;
    };
    /**
     * Handle row events
     */
    EpsilonRepeaterRow.prototype.handleEvents = function (instance) {
        var control = instance, self = this;
        /**
         * Click event on header to toggle minimize
         */
        this.header.on('click', function () {
            control.utils.toggleMinimize(self);
        });
        /**
         * Click event on handler to toggle minimize
         */
        this.container.on('click', '.repeater-row-minimize', function () {
            control.utils.toggleMinimize(self);
        });
        /**
         * Remove row functionality
         */
        this.container.on('click', '.repeater-row-remove', function () {
            control.utils.removeRow(self);
        });
        /**
         * Update row functionality
         */
        this.container.on('keyup change', 'input, select, textarea', function (e) {
            control.utils.updateField(self, jQuery(e.target).data('field'), e.target);
            control.utils.updateLabel(self);
            self.container.trigger('row:update', [self.index, jQuery(e.target).data('field'), e.target]);
        });
    };
    return EpsilonRepeaterRow;
}());
exports.EpsilonRepeaterRow = EpsilonRepeaterRow;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var text_editor_1 = __webpack_require__(2);
var repeater_row_1 = __webpack_require__(8);
var EpsilonRepeaterUtils = /** @class */ (function () {
    /**
     * Constructor
     * @param {EpsilonFieldRepeater | EpsilonSectionRepeater} control
     */
    function EpsilonRepeaterUtils(control) {
        this.control = control;
    }
    /**
     * Deletes a row
     */
    EpsilonRepeaterUtils.prototype.delete = function (row, index) {
        var self = this;
        var settings = this.getValue(), currentRow, i, prop;
        if (settings[index]) {
            // Find the row
            row = this.control.rows[index];
            if (row) {
                // Remove the row settings
                delete settings[index];
                // Remove the row from the rows collection
                delete this.control.rows[index];
            }
        }
        settings = this.cleanArray(settings);
        this.control.rows = self.cleanArray(this.control.rows);
        jQuery.each(this.control.rows, function (index, element) {
            self.setIndex(element, index);
        });
        // Update the new setting values
        this.setValue(settings);
        // Remap the row numbers
        i = 1;
        for (prop in this.control.rows) {
            if (this.control.rows.hasOwnProperty(prop) && this.control.rows[prop]) {
                self.updateLabel(this.control.rows[prop]);
                i++;
            }
        }
    };
    /**
     * Adds a row
     */
    EpsilonRepeaterUtils.prototype.add = function (data) {
        var self = this;
        var template = _.memoize(this.control.template), newSetting = {}, templateData, value = this.getValue(), i, rowContainer, row;
        /**
         * In case we don`t have a template, we terminate here
         */
        if (!template) {
            return false;
        }
        /**
         * Extend template data with what we passed in PHP
         */
        templateData = jQuery.extend(true, {}, this.control.control.params.fields);
        /**
         * In case we added the row with "known" data, we need to overwrite the array
         */
        if (data) {
            for (i in data) {
                if (data.hasOwnProperty(i) && templateData.hasOwnProperty(i)) {
                    templateData[i]['default'] = data[i];
                }
            }
        }
        /**
         * Add an index
         *
         * @type {number}
         */
        templateData['index'] = this.control.currentIndex;
        /**
         * Render the HTML template with underscores
         */
        template = template(templateData);
        rowContainer = jQuery(template).appendTo(this.control.repeaterContainer);
        row = new repeater_row_1.EpsilonRepeaterRow(this.control, rowContainer);
        /**
         * Bind events to the new row
         */
        this.handleRowEvents(row);
        /**
         * Register the new row in the control
         *
         * @type {*}
         */
        this.control.rows[this.control.currentIndex] = row;
        /**
         * Add a new "index" to the setting ( easier to render in the frontend )
         */
        for (i in templateData) {
            if (templateData.hasOwnProperty(i)) {
                newSetting[i] = templateData[i]['default'];
            }
        }
        if ('undefined' === typeof newSetting['index']) {
            newSetting['index'] = this.control.currentIndex;
        }
        /**
         * Add a value to the setting
         * @type {{}}
         */
        value[this.control.currentIndex] = newSetting;
        /**
         * Set it
         */
        if (!data) {
            this.setValue(value);
        }
        this.control.handleRowIncrementor();
        return row;
    };
    /**
     * Sort fields
     */
    EpsilonRepeaterUtils.prototype.sort = function (data) {
        var self = this;
        var rows = this.control.repeaterContainer.find('.repeater-row'), settings = this.getValue(), newOrder = [], newRows = [], newSettings = [], textEditorSettings;
        rows.each(function (i, el) {
            newOrder.push(jQuery(el).data('row'));
        });
        jQuery.each(newOrder, function (newPosition, oldPosition) {
            newRows[newPosition] = self.control.rows[oldPosition];
            self.setIndex(newRows[newPosition], newPosition);
            newSettings[newPosition] = settings[oldPosition];
        });
        var textareas = rows.find('textarea');
        var _loop_1 = function (i) {
            setTimeout(function () {
                var settings = {
                    container: jQuery(textareas[i]).parent(),
                    params: {
                        id: jQuery(textareas[i]).attr('id')
                    }
                };
                new text_editor_1.EpsilonTextEditor(settings, true, true);
            }, 100 * i);
        };
        for (var i = 0; i < textareas.length; i++) {
            _loop_1(i);
        }
        this.control.rows = newRows;
        this.setValue(newSettings);
        if (self.control.control.params['selective_refresh']) {
            wp.customize.previewer.refresh();
        }
    };
    /**
     * Saves value
     */
    EpsilonRepeaterUtils.prototype.setValue = function (value) {
        this.control.control.setting.set([]);
        this.control.control.setting.set(value);
    };
    /**
     * Gets the setting value
     */
    EpsilonRepeaterUtils.prototype.getValue = function () {
        return this.control.control.setting.get();
    };
    /**
     * Update a single field inside a row.
     * Triggered when a field has changed
     */
    EpsilonRepeaterUtils.prototype.updateField = function (instance, fieldId, element) {
        var row = this.control.rows[instance.index], value = this.control.utils.getValue();
        this.updateRepeater(instance, fieldId, element);
    };
    /**
     * Updates a field repeater
     *
     * @param instance
     * @param {string} fieldId
     * @param {JQuery} element
     * @public
     */
    EpsilonRepeaterUtils.prototype.updateRepeater = function (instance, fieldId, element) {
        var row = this.control.rows[instance.index], value = this.control.utils.getValue();
        if (!row) {
            return;
        }
        if (!this.control.control.params.fields[fieldId]) {
            return;
        }
        if (_.isUndefined(value[row.index][fieldId])) {
            return;
        }
        switch (this.control.control.params.fields[fieldId].type) {
            case 'checkbox':
            case 'epsilon-toggle':
                value[row.index][fieldId] = jQuery(element).prop('checked');
                break;
            default:
                value[row.index][fieldId] = jQuery(element).val();
                break;
        }
        this.control.utils.setValue(value);
    };
    /**
     * Load underscores template
     */
    EpsilonRepeaterUtils.prototype.repeaterTemplate = function () {
        var compiled, options = {
            evaluate: /<#([\s\S]+?)#>/g,
            interpolate: /\{\{\{([\s\S]+?)\}\}\}/g,
            escape: /\{\{([^\}]+?)\}\}(?!\})/g,
            variable: 'data'
        };
        return function (data) {
            compiled = _.template(jQuery('.customize-control-epsilon-repeater-content-field').html(), null, options);
            return compiled(data);
        };
    };
    /**
     * Set the row's index
     */
    EpsilonRepeaterUtils.prototype.setIndex = function (row, index) {
        row.index = index;
        row.container.attr('data-row', index);
        row.container.data('row', index);
        this.control.utils.updateLabel(row);
    };
    /**
     * Removes a row from the container
     */
    EpsilonRepeaterUtils.prototype.removeRow = function (row) {
        row.container.slideUp(300, function () {
            jQuery(this).detach();
        });
        row.container.trigger('row:remove', [row.index]);
    };
    /**
     * Update row label
     */
    EpsilonRepeaterUtils.prototype.updateLabel = function (row) {
        var rowLabelField, rowLabel, rowLabelSelector;
        if ('field' === row.label.type) {
            rowLabelField = row.container.find('.repeater-field [data-field="' + row.label.field + '"]');
            if (_.isFunction(rowLabelField.val)) {
                rowLabel = rowLabelField.val();
                if ('' !== rowLabel) {
                    if (!_.isUndefined(this.control.control.params.fields[row.label.field])) {
                        if (!_.isUndefined(this.control.control.params.fields[row.label.field].type)) {
                            if ('select' === this.control.control.params.fields[row.label.field].type) {
                                if (!_.isUndefined(this.control.control.params.fields[row.label.field].choices) &&
                                    !_.isUndefined(this.control.control.params.fields[row.label.field].choices[rowLabel])) {
                                    rowLabel = this.control.control.params.fields[row.label.field].choices[rowLabel];
                                }
                            }
                            else if ('radio' === this.control.control.params.fields[row.label.field].type || 'radio-image' === this.control.control.params.fields[row.label.field].type) {
                                rowLabelSelector = this.control.control.selector + ' [data-row="' + row.index + '"] .repeater-field [data-field="' + row.label.field + '"]:checked';
                                rowLabel = jQuery(rowLabelSelector).val();
                            }
                        }
                    }
                    row.header.find('.repeater-row-label').text(rowLabel);
                    return;
                }
            }
        }
        row.header.find('.repeater-row-label').text(row.label.value + ' ' + (row.index + 1));
    };
    /**
     * Toggles the row vizibility
     */
    EpsilonRepeaterUtils.prototype.toggleMinimize = function (row, section) {
        if (section === void 0) { section = false; }
        var self = this;
        if (row.hasOwnProperty('type')) {
            section = true;
        }
        row.container.find('.repeater-row-content').slideToggle(300, function () {
            row.container.toggleClass('minimized');
            row.header.find('.dashicons').toggleClass('dashicons-arrow-up').toggleClass('dashicons-arrow-down');
            /**
             * In case we are in a section, we need to close others
             */
            if (section) {
                jQuery('body').removeClass('adding-section');
                jQuery('body').removeClass('adding-doubled-section');
                jQuery('#sections-left-' + self.control.control.params.id).find('.available-sections').removeClass('opened');
                jQuery.each(row.container.siblings(), function (index, element) {
                    if (!jQuery(element).hasClass('minimized')) {
                        jQuery(element).addClass('minimized');
                        jQuery(element).find('.repeater-row-content').slideToggle(300, function () {
                            jQuery(element).
                                find('repeater-row-header').
                                addClass('minimized').
                                find('.dashicons').
                                toggleClass('dashicons-arrow-up').
                                toggleClass('dashicons-arrow-down');
                        });
                    }
                });
            }
        });
    };
    /**
     * Cleans an arrow of undefined values
     */
    EpsilonRepeaterUtils.prototype.cleanArray = function (obj) {
        var arr = [];
        for (var i = 0; i < obj.length; i++) {
            if (obj[i]) {
                arr.push(obj[i]);
            }
        }
        return arr;
    };
    /**
     * Handle row events
     */
    EpsilonRepeaterUtils.prototype.handleRowEvents = function (row) {
        var self = this;
        /**
         * 1. Remove row event
         */
        row.container.on('row:remove', function (e, index) {
            self.delete(row, index);
            if ('epsilon-section-repeater' === self.control.control.params.type) {
                jQuery('body').removeClass('adding-doubled-section');
            }
            if (self.control.control.params['selective_refresh']) {
                wp.customize.previewer.refresh();
            }
        });
        /**
         * 2. Initiate sortable script
         */
        row.header.on('mousedown', function () {
            row.container.trigger('row:start-dragging');
        });
    };
    return EpsilonRepeaterUtils;
}());
exports.EpsilonRepeaterUtils = EpsilonRepeaterUtils;


/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var button_group_1 = __webpack_require__(3);
wp.customize.controlConstructor['epsilon-button-group'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new button_group_1.EpsilonButtonGroup(control);
    }
});


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var color_picker_1 = __webpack_require__(4);
wp.customize.controlConstructor['epsilon-color-picker'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new color_picker_1.EpsilonColorPicker(control);
        control.container.on('change', 'input.epsilon-color-picker', function (e) {
            control.setting.set(jQuery(e.target).val());
        });
    }
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var color_schemes_1 = __webpack_require__(34);
/**
 * Epsilon Color Schemes Control Constructor
 */
wp.customize.controlConstructor['epsilon-color-scheme'] = wp.customize.Control.extend({
    ready: function () {
        var control = this, section, instance;
        wp.customize.bind('ready', function () {
            new color_schemes_1.EpsilonColorSchemes(control);
        });
        /**
         * Save the typography
         */
        control.container.on('change', '.epsilon-color-scheme-input', function (e) {
            control.setting.set(jQuery(e.target).val());
        });
    }
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var customizer_navigation_1 = __webpack_require__(5);
wp.customize.controlConstructor['epsilon-customizer-navigation'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new customizer_navigation_1.EpsilonCustomizerNavigation(control);
    }
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var icon_picker_1 = __webpack_require__(35);
wp.customize.controlConstructor['epsilon-icon-picker'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new icon_picker_1.EpsilonIconPicker(control, false);
        control.container.on('change', 'input.epsilon-icon-picker', function (event) {
            control.setting.set(jQuery(event.target).val());
        });
    }
});


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __webpack_require__(36);
wp.customize.controlConstructor['epsilon-image'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new image_1.EpsilonImage(control);
    }
});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var layouts_1 = __webpack_require__(37);
wp.customize.controlConstructor['epsilon-layouts'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new layouts_1.EpsilonLayouts(control);
        /**
         * Save the layout
         */
        control.container.on('change', 'input', function (e) {
            control.setting.set(jQuery(e.target).val());
        });
    }
});


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var range_slider_1 = __webpack_require__(1);
wp.customize.controlConstructor['epsilon-slider'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new range_slider_1.EpsilonRangeSlider(control);
        control.container.on('change', 'input.rl-slider', function (event) {
            control.setting.set(jQuery(event.target).val());
        });
    }
});


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var repeater_1 = __webpack_require__(6);
wp.customize.controlConstructor['epsilon-repeater'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new repeater_1.EpsilonFieldRepeater(control);
    }
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var section_repeater_1 = __webpack_require__(40);
wp.customize.controlConstructor['epsilon-section-repeater'] = wp.customize.Control.extend({
    ready: function () {
        var control = this, id = jQuery(this.container).attr('id'), node = document.getElementById(id), observer = new MutationObserver(function (mutations) {
            var element = mutations[mutations.length - 1];
            if (jQuery(element.target).is(':visible') && !jQuery(element.target).hasClass('epsilon-section-repeater-initiated')) {
                jQuery(element.target).addClass('epsilon-section-repeater-initiated');
                new section_repeater_1.EpsilonSectionRepeater(control);
            }
        });
        if (this.container.is(':visible')) {
            this.container.addClass('epsilon-section-repeater-initiated');
            new section_repeater_1.EpsilonSectionRepeater(control);
        }
        if (null !== node) {
            observer.observe(node, { attributes: true, childList: false, attributeFilter: ['style'] });
        }
    }
});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var text_editor_1 = __webpack_require__(2);
wp.customize.controlConstructor['epsilon-text-editor'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new text_editor_1.EpsilonTextEditor(control);
        control.container.on('change keyup', 'textarea', function (event) {
            control.setting.set(jQuery(event.target).val());
        });
    }
});


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

wp.customize.controlConstructor['epsilon-toggle'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        control.container.on('change', 'input.onoffswitch-checkbox', function (e) {
            control.setting.set(jQuery(e.target).prop('checked'));
        });
    }
});


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var typography_1 = __webpack_require__(41);
/**
 * Epsilon Typography Control Constructor
 */
wp.customize.controlConstructor['epsilon-typography'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new typography_1.EpsilonTypography(control);
        /**
         * Save the typography
         */
        control.container.on('change', '.customize-control-content > .epsilon-typography-input', function (e) {
            control.setting.set(jQuery(e.target).val());
        });
    }
});


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

wp.customize.controlConstructor['epsilon-upsell'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        control.container.on('click', '.epsilon-upsell-label', function (e) {
            e.preventDefault();
            jQuery(this).toggleClass('opened').find('i').toggleClass('dashicons-arrow-down-alt2 dashicons-arrow-up-alt2');
            control.container.find('.epsilon-upsell-container').slideToggle(200);
        });
    }
});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Nestable Regular Panels Constructor
 */
wp.customize.panelConstructor['epsilon-panel-regular'] = wp.customize.Panel.extend({
    /**
     * Embed Panel
     */
    _panelEmbed: wp.customize.Panel.prototype.embed,
    /**
     * Check if is contextually active
     */
    _panelIsContextuallyActive: wp.customize.Panel.prototype.isContextuallyActive,
    /**
     * Attach Events
     */
    _panelAttachEvents: wp.customize.Panel.prototype.attachEvents,
    /**
     * Ready event
     */
    ready: function () {
        /**
         * Hide the panel
         */
        if (this.params.hidden) {
            this.container.addClass('epsilon-hidden');
        }
        wp.customize.bind('pane-contents-reflowed', function () {
            // Reflow panels
            var panels = [];
            wp.customize.panel.each(function (panel) {
                if ('epsilon-panel-regular' !== panel.params.type || 'undefined' === typeof panel.params.panel) {
                    return;
                }
                panels.push(panel);
            });
            panels.sort(wp.customize.utils.prioritySort).reverse();
            jQuery.each(panels, function (i, panel) {
                var parentContainer = jQuery('#sub-accordion-panel-' + panel.params.panel);
                parentContainer.children('.panel-meta').after(panel.headContainer);
            });
            jQuery(document).trigger('epsilon-reflown-panels');
        });
    },
    /**
     * Attach events
     */
    attachEvents: function () {
        var panel = this;
        if ('epsilon-panel-regular' !== this.params.type || 'undefined' === typeof this.params.panel) {
            this._panelAttachEvents.call(this);
            return;
        }
        this._panelAttachEvents.call(this);
        panel.expanded.bind(function (expanded) {
            var parent = wp.customize.panel(panel.params.panel);
            if (expanded) {
                parent.contentContainer.addClass('current-panel-parent');
            }
            else {
                parent.contentContainer.removeClass('current-panel-parent');
            }
        });
        panel.container.find('.customize-panel-back').off('click keydown').on('click keydown', function (event) {
            if (wp.customize.utils.isKeydownButNotEnterEvent(event)) {
                return;
            }
            event.preventDefault();
            if (panel.expanded()) {
                wp.customize.panel(panel.params.panel).expand();
            }
        });
    },
    /**
     * Is contextually active
     * @returns {*}
     */
    isContextuallyActive: function () {
        var panel = this, children = this._children('panel', 'section'), activeCount = 0;
        if ('epsilon-panel-regular' !== this.params.type) {
            return this._panelIsContextuallyActive.call(this);
        }
        wp.customize.panel.each(function (child) {
            if (!child.params.panel) {
                return;
            }
            if (child.params.panel !== panel.id) {
                return;
            }
            children.push(child);
        });
        children.sort(wp.customize.utils.prioritySort);
        _(children).each(function (child) {
            if (child.active() && child.isContextuallyActive()) {
                activeCount += 1;
            }
        });
        return (0 !== activeCount);
    },
    /**
     * Embed
     */
    embed: function () {
        var panel = this, parentContainer = jQuery('#sub-accordion-panel-' + this.params.panel);
        if ('epsilon-panel-regular' !== this.params.type || 'undefined' === typeof this.params.panel) {
            this._panelEmbed.call(this);
            return;
        }
        this._panelEmbed.call(this);
        parentContainer.append(panel.headContainer);
    },
});


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var recommended_actions_1 = __webpack_require__(43);
/**
 * Recommended Section Constructor
 */
wp.customize.sectionConstructor['epsilon-section-recommended-actions'] = wp.customize.Section.extend({
    ready: function () {
        new recommended_actions_1.EpsilonSectionRecommended(this);
    },
    attachEvents: function () {
    },
    isContextuallyActive: function () {
        return true;
    }
});


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var section_doubled_1 = __webpack_require__(44);
/**
 * Doubled Section Constructor
 */
wp.customize.sectionConstructor['epsilon-section-doubled'] = wp.customize.Section.extend({
    ready: function () {
        var section = this;
        new section_doubled_1.EpsilonSectionDoubled(section);
    },
    attachEvents: function () {
    },
    isContextuallyActive: function () {
        return true;
    }
});


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Pro Section Constructor
 */
wp.customize.sectionConstructor['epsilon-section-pro'] = wp.customize.Section.extend({
    attachEvents: function () {
    },
    isContextuallyActive: function () {
        return true;
    }
});


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Color Schemes Module
 */
var EpsilonColorSchemes = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; params: {value: number; id: string}}} control
     */
    function EpsilonColorSchemes(control) {
        this.control = control;
        this.context = this.control.container.find('.epsilon-color-scheme');
        if (!this.context.length) {
            return;
        }
        this.init();
    }
    /**
     * Initiator
     */
    EpsilonColorSchemes.prototype.init = function () {
        var self = this;
        /**
         * Set variables
         */
        var options = this.context.find('.epsilon-color-scheme-option'), input = this.context.parent().find('[data-customize-setting-link]').first(), json = jQuery.parseJSON(options.first().find('input').val()), api = wp.customize, colorSettings = [], css = {
            action: 'epsilon_generate_color_scheme_css',
            class: 'Epsilon_Color_Scheme',
            id: '',
            data: {}
        };
        jQuery.each(json, function (index, value) {
            colorSettings.push(index);
        });
        _.each(colorSettings, function (setting) {
            css.data[setting] = api(setting)();
            if ('undefined' !== typeof api.control(setting)) {
                api.control(setting).container.on('change', 'input.epsilon-color-picker', _.debounce(function () {
                    self.context.siblings('.epsilon-color-scheme-selected').
                        find('.epsilon-color-scheme-palette').
                        find('*[data-field-id="' + setting + '"]').
                        css('background', jQuery(this).attr('value'));
                    css.data[setting] = api(setting)();
                    api.previewer.send('update-inline-color-schemes-css', css);
                }, 800));
            }
        });
        /**
         * On clicking a color scheme, update the color pickers
         */
        options.on('click', function () {
            var val = jQuery(this).attr('data-color-id'), json = jQuery(this).find('input').val();
            if (json) {
                json = jQuery.parseJSON(json);
            }
            /**
             * Find the customizer options
             */
            jQuery.each(json, function (index, value) {
                /**
                 * Set values
                 */
                jQuery('#customize-control-' + index + ' .epsilon-color-picker').minicolors('value', value);
                api(index).set(value);
                self.context.siblings('.epsilon-color-scheme-selected').find('.epsilon-color-scheme-palette').find('*[data-field-id="' + index + '"]').css('background', value);
            });
            /**
             * Remove the selected class from siblings
             */
            jQuery(this).siblings('.epsilon-color-scheme-option').removeClass('selected');
            /**
             * Make active the current selection
             */
            jQuery(this).addClass('selected');
            /**
             * Trigger change
             */
            input.val(val).trigger('change');
        });
        /**
         * Advanced toggler
         */
        jQuery('.epsilon-control-dropdown').on('click', function () {
            jQuery(this).toggleClass('active');
            jQuery(this).find('span').toggleClass('dashicons-arrow-down dashicons-arrow-up');
            self.context.slideToggle();
        });
    };
    return EpsilonColorSchemes;
}());
exports.EpsilonColorSchemes = EpsilonColorSchemes;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Icon Picker Module
 */
var EpsilonIconPicker = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; params: {value: number; id: string}}} control
     */
    function EpsilonIconPicker(control, repeater) {
        this.control = control;
        this.context = this.control.container;
        this.collection = this.context.find('.epsilon-icons > i');
        this.searchInput = this.context.find('.search-container input');
        this.inRepeater = repeater;
        this.handleEvents();
    }
    /**
     * Handle events
     */
    EpsilonIconPicker.prototype.handleEvents = function () {
        var self = this;
        var icon, label, temp, filter;
        /**
         * Icon container toggler
         */
        this.context.on('click', '.epsilon-icon-container', function (e) {
            e.preventDefault();
            jQuery(e.target).toggleClass('opened-icon-picker');
            self.context.find('.epsilon-icon-picker-container').toggleClass('opened');
        });
        /**
         * Icon selection
         */
        this.context.on('click', '.epsilon-icons-container .epsilon-icons > i', function (e) {
            self.context.find('.epsilon-icons > i.selected').removeClass('selected');
            icon = jQuery(e.target).addClass('selected').attr('data-icon');
            label = jQuery(e.target).addClass('selected').attr('data-search');
            self.context.find('.epsilon-icon-name > i').removeClass().addClass(icon);
            self.context.find('.epsilon-icon-name > .icon-label').html(label);
            /**
             * Set value
             */
            if (!self.inRepeater) {
                self.control.setting.set(icon);
            }
            else {
                self.context.find('.epsilon-icon-picker').attr('value', icon).trigger('change');
            }
        });
        /**
         * Search functionality
         */
        self.context.on('keyup change', '.search-container input', _.debounce(function (e) {
            filter = self.searchInput.val();
            if ('undefined' !== typeof filter) {
                filter = filter.toLowerCase();
            }
            jQuery.each(self.collection, function () {
                temp = jQuery(this).attr('data-search');
                if ('undefined' !== typeof temp) {
                    temp = temp.toLowerCase();
                }
                jQuery(this)[temp.indexOf(filter) !== -1 ? 'show' : 'hide']();
            });
        }, 1000));
    };
    return EpsilonIconPicker;
}());
exports.EpsilonIconPicker = EpsilonIconPicker;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = __webpack_require__(0);
/**
 * Epsilon Image
 */
var EpsilonImage = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; params: {value: number; id: string}}} control
     */
    function EpsilonImage(control) {
        this.control = control;
        this.context = jQuery(control.container);
        this.handleEvents();
    }
    /**
     * Event handling ( click events )
     */
    EpsilonImage.prototype.handleEvents = function () {
        var self = this;
        var image, temp, size, thumb, setting = { id: '', url: '' }, input = this.context.find('.epsilon-controller-image-container > input');
        /**
         * Image selection
         */
        this.context.on('click', '.image-upload-button', function (e) {
            /**
             * Open the wp.media frame
             */
            image = wp.media({
                multiple: false,
            }).open();
            /**
             * On selection, save the data in a JSON
             */
            image.on('select', function () {
                temp = image.state().get('selection').first();
                size = input.attr('data-size');
                if ('undefined' === typeof (temp.toJSON().sizes[size])) {
                    size = 'full';
                }
                setting.id = temp.id;
                setting.url = temp.toJSON().sizes[size].url;
                self.saveValue(setting);
                self.setImage(setting.url);
                /**
                 * Show buttons
                 */
                self.context.find('.actions .image-upload-remove-button').show();
                if (!_.isEmpty(self.control.params.default)) {
                    self.context.find('.actions .image-default-button').show();
                }
            });
        });
        /**
         * Image deletion
         */
        this.context.on('click', '.image-upload-remove-button', function (e) {
            e.preventDefault();
            thumb = self.context.find('.epsilon-image');
            self.saveValue({ id: '', url: '' });
            if (thumb.length) {
                thumb.find('img').fadeOut(200, function () {
                    var html = EpsilonTranslations.selectFile + '<span class="recommended-size"></span>', Ajax, data = {
                        action: ['Epsilon_Helper', 'get_image_sizes'],
                        nonce: EpsilonWPUrls.ajax_nonce,
                        args: [],
                    };
                    thumb.removeClass('epsilon-image').addClass('placeholder').html(html);
                    Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(data);
                    Ajax.request();
                    jQuery(Ajax).on('epsilon-received-success', function (e) {
                        if (!_.isUndefined(Ajax.result[size])) {
                            thumb.find('.recommended-size').text(Ajax.result[size].width + ' x ' + Ajax.result[size].height);
                        }
                    });
                });
            }
            /**
             * If we don`t have an image, we can hide these buttons
             */
            jQuery(e.target).hide();
            if (!_.isEmpty(self.control.params.default)) {
                self.context.find('.actions .image-default-button').show();
            }
        });
        self.context.on('click', '.image-default-button', function (e) {
            e.preventDefault();
            thumb = self.context.find('.epsilon-image');
            self.saveValue(self.control.params.default);
            self.setImage(self.control.params.default.url);
            self.context.find('.actions .image-upload-remove-button').show();
        });
    };
    /**
     * Set image in the customizer option control
     *
     * @param control
     * @param image
     */
    EpsilonImage.prototype.setImage = function (image) {
        /**
         * If we already have an image, we need to return that div, else we grab the placeholder
         *
         * @type {*}
         */
        var thumb = this.context.find('.epsilon-image').length ? this.context.find('.epsilon-image') : this.context.find('.placeholder');
        /**
         * We "reload" the image container
         */
        if (thumb.length) {
            thumb.removeClass('epsilon-image placeholder').addClass('epsilon-image');
            thumb.html('');
            thumb.append('<img style="display:none" src="' + image + '" />');
            thumb.find('img').fadeIn(200);
        }
    };
    /**
     * Save value in database
     *
     * @param control
     * @param val
     */
    EpsilonImage.prototype.saveValue = function (val) {
        var input = this.context.find('.epsilon-controller-image-container > input');
        if ('object' === typeof (val) && '' !== val.id) {
            this.control.setting.set(JSON.stringify(val));
            jQuery(input).attr('value', JSON.stringify(val)).trigger('change');
        }
        else {
            this.control.setting.set('');
            jQuery(input).attr('value', '').trigger('change');
        }
    };
    return EpsilonImage;
}());
exports.EpsilonImage = EpsilonImage;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Layouts Module
 */
var EpsilonLayouts = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; setting: void; params: {value: number; id: string}}} control
     */
    function EpsilonLayouts(control) {
        /**
         * Buttons
         */
        this.html = {
            buttonLeft: '<a href="#" data-action="left"><span class="dashicons dashicons-arrow-left"></span> </a>',
            buttonRight: '<a href="#" data-action="right"><span class="dashicons dashicons-arrow-right"></span> </a>',
        };
        /**
         * Number of active columns
         */
        this.activeColumns = null;
        /**
         * Redundant constant for columns
         */
        this.colClasses = 'col12 col11 col10 col9 col8 col7 col6 col5 col4 col3 col2 col1';
        this.control = control;
        this.context = this.control.container;
        this.layoutButtons = this.context.find('.epsilon-control-group > a');
        this.resizeButtons = this.context.find('.epsilon-layouts-setup > .epsilon-column > a');
        this.maxColumns = this.layoutButtons.length;
        this.minSpan = parseFloat(this.control.params.minSpan);
        this.lastColumnsState = null;
        this.dataLink = this.context.find('[data-customize-setting-link]').first();
        /**
         * Handle actions
         */
        this.handle_actions();
        /**
         * Whenever the column count or size changes, we save data to the hidden field
         */
        this.context.on('epsilon_column_count_changed epsilon_column_size_changed', this._save);
    }
    /**
     * Handle the click events in the control
     */
    EpsilonLayouts.prototype.handle_actions = function () {
        /**
         * Hide / show columns
         */
        this._advanced_toggler();
        /**
         * Column resize event ( + / - buttons )
         */
        this._column_resize();
        /**
         * Addition removal of columns events
         */
        this._column_recount();
        this._layout_select();
        this._equalize_columns();
    };
    /**
     * Advanced toggler
     *
     * @private
     */
    EpsilonLayouts.prototype._advanced_toggler = function () {
        /**
         * On clicking the advanced options toggler,
         */
        this.context.on('click', '.epsilon-control-advanced', function (e) {
            e.preventDefault();
            jQuery(this).toggleClass('active');
            jQuery('#' + jQuery(this).attr('data-unique-id')).slideToggle().addClass('active');
        });
    };
    /**
     * Column Resizer
     * @private
     */
    EpsilonLayouts.prototype._column_resize = function () {
        var self = this;
        var position, elementToSubtractFrom, elementToAddOn;
        this.context.on('click', '.epsilon-column > a', function (e) {
            elementToAddOn = jQuery(this).parent();
            position = elementToAddOn.index();
            if ('right' === jQuery(this).attr('data-action')) {
                elementToSubtractFrom = self.context.find('.epsilon-layouts-setup > .epsilon-column').eq(position + 1);
            }
            else {
                elementToSubtractFrom = self.context.find('.epsilon-layouts-setup > .epsilon-column').eq(position - 1);
            }
            self._calc_column_resize(elementToSubtractFrom, elementToAddOn);
        });
    };
    /**
     * Handle addition/removal of columns
     * @private
     */
    EpsilonLayouts.prototype._column_recount = function () {
        var self = this;
        var columns, operation, i, j;
        this.context.on('epsilon_column_count_change', function (e) {
            /**
             * Update instance variables
             */
            self.activeColumns = parseFloat(e.columns.selected);
            self.lastColumnsState = e.columns.beforeSelection;
            /**
             * In case we don't have anything to modify, we can terminate here
             */
            if (self.activeColumns === self.lastColumnsState) {
                return;
            }
            /**
             * Are we adding or subtrating?
             */
            operation = self.lastColumnsState < self.activeColumns ? 'adding' : 'subtracting';
            i = self.activeColumns - self.lastColumnsState;
            if ('subtracting' === operation) {
                self.context.find('.epsilon-layouts-setup > .epsilon-column').
                    slice(-(self.lastColumnsState - self.activeColumns)).
                    remove();
            }
            else {
                for (j = 0; j < i; j++) {
                    self.context.find('.epsilon-layouts-setup').
                        append('<div class="epsilon-column col4">' +
                        self.html.buttonLeft +
                        self.html.buttonRight +
                        '</div>');
                }
            }
            /**
             * Trigger event to changed
             */
            self.context.trigger({
                type: 'epsilon_column_count_changed',
                instance: self
            });
        });
    };
    /**
     * When selecting a layout, recalc/remove/readd divs in the container
     *
     * @private
     */
    EpsilonLayouts.prototype._layout_select = function () {
        var self = this;
        var columns;
        this.layoutButtons.on('click', function (e) {
            e.preventDefault();
            var selected = jQuery(this).attr('data-button-value');
            /**
             * Handle addition/deletion through jQuery events
             */
            self.context.trigger({
                type: 'epsilon_column_count_change',
                columns: {
                    selected: parseFloat(selected),
                    beforeSelection: self.context.find('.epsilon-layouts-setup > .epsilon-column').length
                }
            });
            /**
             * Visual changes
             */
            jQuery(this).addClass('active').siblings('a').removeClass('active');
        });
    };
    /**
     * Equalize coolumns, this is happening after a new layout is selected
     * @private
     */
    EpsilonLayouts.prototype._equalize_columns = function () {
        var self = this;
        this.context.on('epsilon_column_count_changed', function (e) {
            switch (self.activeColumns) {
                case 2:
                    self.context.find('.epsilon-column').removeClass(self.colClasses);
                    self.context.find('.epsilon-column').first().addClass('col8').attr('data-columns', (8));
                    self.context.find('.epsilon-column').last().addClass('col4').attr('data-columns', (4));
                    break;
                default:
                    if (null === self.activeColumns) {
                        return;
                    }
                    self.context.find('.epsilon-column').
                        removeClass(self.colClasses).
                        addClass('col' + (12 / self.activeColumns)).
                        attr('data-columns', (12 / self.activeColumns));
                    break;
            }
        });
    };
    /**
     * Change spans accordingly
     *
     * @param subtract
     * @param add
     */
    EpsilonLayouts.prototype._calc_column_resize = function (subtract, add) {
        var columns = subtract.attr('data-columns'), addColumns;
        if ('undefined' === typeof columns) {
            return;
        }
        columns = parseFloat(columns);
        if (parseFloat(columns) === this.minSpan) {
            return;
        }
        addColumns = add.attr('data-columns');
        addColumns = parseFloat(addColumns);
        subtract.attr('data-columns', columns - 1).removeClass(this.colClasses).addClass('col' + (columns - 1));
        add.attr('data-columns', addColumns + 1).removeClass(this.colClasses).addClass('col' + (addColumns + 1));
        /**
         * Trigger event to change
         */
        this.context.trigger({
            type: 'epsilon_column_size_changed',
            instance: this
        });
    };
    /**
     * Save state in a json
     * @private
     */
    EpsilonLayouts.prototype._save = function (e) {
        var json = {
            columnsCount: e.instance.activeColumns,
            columns: {}
        };
        jQuery.each(e.instance.context.find('.epsilon-column'), function (index) {
            var columns = jQuery(this).attr('data-columns');
            if ('undefined' === typeof columns) {
                return;
            }
            columns = parseFloat(columns);
            var Obj = {
                index: index + 1,
                span: columns
            };
            json.columns[index + 1] = Obj;
        });
        if (null === json.columnsCount) {
            json.columnsCount = e.instance.context.find('.epsilon-column').length;
        }
        e.instance.dataLink.val(JSON.stringify(json)).trigger('change');
    };
    return EpsilonLayouts;
}());
exports.EpsilonLayouts = EpsilonLayouts;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var repeater_row_1 = __webpack_require__(8);
var EpsilonRepeaterSectionRow = /** @class */ (function (_super) {
    __extends(EpsilonRepeaterSectionRow, _super);
    /**
     * Constructor
     * @param {EpsilonSectionRepeater | EpsilonFieldRepeater} instance
     * @param {JQuery} rowContainer
     * @param {string} type
     */
    function EpsilonRepeaterSectionRow(instance, rowContainer, type) {
        var _this = _super.call(this, instance, rowContainer) || this;
        _this.type = type;
        _this.label = instance.control.params.sections[type].title;
        /**
         * Update labels
         */
        instance.utils.updateLabel(_this);
        _this.addTabs();
        return _this;
    }
    /**
     * Add tabs functionality ( sections have layout/styling optional settings )
     */
    EpsilonRepeaterSectionRow.prototype.addTabs = function () {
        jQuery(this.container).find('[data-group="regular"]').wrapAll('<div data-tab-id="regular" class="tab-panel regular active"></div>');
        jQuery(this.container).find('[data-group="styling"]').wrapAll('<div data-tab-id="styling" class="tab-panel styling"></div>');
        jQuery(this.container).find('[data-group="layout"]').wrapAll('<div data-tab-id="layout" class="tab-panel layout"></div>');
        this._handleTabs();
    };
    /**
     * Handle tabs functionality
     * @param container
     */
    EpsilonRepeaterSectionRow.prototype._handleTabs = function () {
        var self = this;
        var wrapper = self.container.find('nav'), tabs = self.container.find('[data-tab-id]'), tab;
        jQuery(wrapper).on('click', 'a', function (event) {
            event.preventDefault();
            jQuery(this).siblings().removeClass('active');
            jQuery(this).addClass('active');
            tab = self.container.find('[data-tab-id="' + jQuery(this).attr('data-item') + '"]');
            if (tab.length) {
                tabs.removeClass('active');
                tab.addClass('active');
            }
        });
    };
    /**
     * We'll overwrite label immediatly after construct
     * @returns {any}
     */
    EpsilonRepeaterSectionRow.prototype.getLabel = function () {
        return this.label;
    };
    return EpsilonRepeaterSectionRow;
}(repeater_row_1.EpsilonRepeaterRow));
exports.EpsilonRepeaterSectionRow = EpsilonRepeaterSectionRow;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var repeater_utils_1 = __webpack_require__(9);
var repeater_section_row_1 = __webpack_require__(38);
var EpsilonRepeaterSectionUtils = /** @class */ (function (_super) {
    __extends(EpsilonRepeaterSectionUtils, _super);
    /**
     * constructor
     * @param {EpsilonFieldRepeater | EpsilonSectionRepeater} control
     */
    function EpsilonRepeaterSectionUtils(control) {
        return _super.call(this, control) || this;
    }
    /**
     * Add button
     * @param instance
     */
    EpsilonRepeaterSectionUtils.prototype.addButton = function () {
        var self = this;
        var isAddBtn, sections = jQuery('#sections-left-' + self.control.control.params.id).find('.available-sections'), body = jQuery('body');
        /**
         * Get a reference for the parent section, if we close it. we must close the Section sidebar as well
         */
        wp.customize['section'](this.control.control.params.section, function (instance) {
            instance.container.find('.accordion-section-title, .customize-section-back').on('click keydown', function (event) {
                if (wp.customize.utils.isKeydownButNotEnterEvent(event)) {
                    return;
                }
                /**
                 * In case we left the "sections" screen, let's close all the repeatable sections
                 */
                _.each(self.control.rows, function (sect) {
                    if (!sect.container.hasClass('minimized')) {
                        self.toggleMinimize(sect, true);
                    }
                });
                body.removeClass('adding-section');
                body.find('.doubled-section-opened').removeClass('doubled-section-opened');
                sections.removeClass('opened');
            });
        });
        this.control.context.find('.epsilon-add-new-section').on('click keydown', function (e) {
            if (jQuery('body').hasClass('adding-doubled-section')) {
                return;
            }
            isAddBtn = jQuery(e.target).is('.epsilon-add-new-section');
            body.toggleClass('adding-section');
            sections.toggleClass('opened');
            if (body.hasClass('adding-section') && !isAddBtn) {
                self.control.control.close();
            }
        });
    };
    /**
     * Overwrite base method
     */
    EpsilonRepeaterSectionUtils.prototype.repeaterTemplate = function () {
        var compiled, options = {
            evaluate: /<#([\s\S]+?)#>/g,
            interpolate: /\{\{\{([\s\S]+?)\}\}\}/g,
            escape: /\{\{([^\}]+?)\}\}(?!\})/g,
            variable: 'data'
        };
        return function (data) {
            compiled = _.template(jQuery('.customize-control-epsilon-repeater-content-section').html(), null, options);
            return compiled(data);
        };
    };
    /**
     * Overwrite base method
     */
    EpsilonRepeaterSectionUtils.prototype.add = function (data) {
        var self = this;
        var template = _.memoize(this.control.template), newSetting = {}, templateData, value = self.getValue(), i, rowContainer, row, fields;
        /**
         * In case we don`t have a template, we terminate here
         */
        if (!template) {
            return false;
        }
        /**
         * Extend template data with what we passed in PHP
         */
        if ('undefined' === typeof (this.control.control.params.sections[data.type])) {
            return false;
        }
        /**
         * Form the new fields with the static ones
         */
        fields = jQuery.extend(true, {}, this.control.control.params.sections[data.type].fields, this.control.control.params.sections[data.type].customization.styling, this.control.control.params.sections[data.type].customization.layout);
        /**
         * Extend template data with what we passed in PHP
         */
        templateData = jQuery.extend(true, {}, fields, { customization: this.control.control.params.sections[data.type].customization });
        /**
         * In case we added the row with "known" data, we need to overwrite the array
         */
        if (data) {
            for (i in data) {
                if (data.hasOwnProperty(i) && templateData.hasOwnProperty(i)) {
                    templateData[i]['default'] = data[i];
                }
            }
        }
        /**
         * Add an index
         *
         * @type {number}
         */
        templateData['index'] = this.control.currentIndex;
        /**
         * Render the HTML template with underscores
         */
        template = template(templateData);
        rowContainer = jQuery(template).appendTo(this.control.repeaterContainer);
        row = new repeater_section_row_1.EpsilonRepeaterSectionRow(this.control, rowContainer, data.type);
        /**
         * Bind events to the new row
         */
        this.handleRowEvents(row);
        /**
         * Register the new row in the control
         *
         * @type {*}
         */
        this.control.rows[this.control.currentIndex] = row;
        /**
         * Add a new "index" to the setting ( easier to render in the frontend )
         */
        for (i in templateData) {
            if (templateData.hasOwnProperty(i)) {
                newSetting[i] = templateData[i]['default'];
            }
        }
        newSetting.type = data.type;
        if ('undefined' === typeof newSetting['index']) {
            newSetting['index'] = this.control.currentIndex;
        }
        /**
         * Add a value to the setting
         * @type {{}}
         */
        value[this.control.currentIndex] = newSetting;
        /**
         * Set it
         */
        if (1 === _.size(data) && data.hasOwnProperty('type')) {
            self.setValue(value);
        }
        this.control.handleRowIncrementor();
        return row;
    };
    /**
     * Override parent method
     */
    EpsilonRepeaterSectionUtils.prototype.updateLabel = function (section) {
        section.header.find('.repeater-row-label').html('<span class="repeater-index">#' + (section.index + 1) + ' - </span>' + section.label);
    };
    ;
    /**
     * Update a section repeater
     * @param instance
     * @param {string} fieldId
     * @param {JQuery} element
     * @public
     */
    EpsilonRepeaterSectionUtils.prototype.updateRepeater = function (instance, fieldId, element) {
        var self = this;
        var row = this.control.rows[instance.index], value = this.getValue(), section, type, data;
        if (!row) {
            return;
        }
        if (_.isUndefined(value[row.index][fieldId])) {
            return;
        }
        type = this.getFieldGroup(fieldId, row.type);
        switch (type) {
            case 'checkbox':
            case 'epsilon-toggle':
                value[row.index][fieldId] = jQuery(element).prop('checked');
                break;
            default:
                value[row.index][fieldId] = jQuery(element).val();
                break;
        }
        if (self.control.control.params['selective_refresh']) {
            /**
             * Partial refresh
             * @type {{control; postId; index: any; value: any}}
             */
            data = {
                control: this.control.control.id,
                postId: this.control.control.params['save_as_meta'],
                value: value[row.index],
                index: row.index,
            };
            wp.customize.previewer.send('updated-section-repeater', data);
        }
        this.setValue(value);
    };
    /**
     *
     * @param instance
     * @param sectionType
     */
    EpsilonRepeaterSectionUtils.prototype.getFieldGroup = function (fieldId, sectionType) {
        if (this.control.control.params.sections[sectionType].fields[fieldId]) {
            return this.control.control.params.sections[sectionType].fields[fieldId].type;
        }
        if (this.control.control.params.sections[sectionType].customization.styling[fieldId]) {
            return this.control.control.params.sections[sectionType].customization.styling[fieldId].type;
        }
        if (this.control.control.params.sections[sectionType].customization.layout[fieldId]) {
            return this.control.control.params.sections[sectionType].customization.layout[fieldId].type;
        }
    };
    return EpsilonRepeaterSectionUtils;
}(repeater_utils_1.EpsilonRepeaterUtils));
exports.EpsilonRepeaterSectionUtils = EpsilonRepeaterSectionUtils;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var repeater_1 = __webpack_require__(6);
var repeater_section_utils_1 = __webpack_require__(39);
var repeater_addons_1 = __webpack_require__(7);
var EpsilonSectionRepeater = /** @class */ (function (_super) {
    __extends(EpsilonSectionRepeater, _super);
    /**
     * Object constructor
     * @param control
     */
    function EpsilonSectionRepeater(control) {
        var _this = _super.call(this, control) || this;
        /**
         * We need to move this element to the bottom of the page so it renders properly
         */
        _this._moveElements();
        /**
         * Events that fires from the main page
         * so we can focus our panel and repeatable section
         */
        _this._handleNavigation();
        /**
         * Initiate Search on sections
         */
        _this._initSearch();
        /**
         * Handle integration tab functionality
         */
        _this._handleIntegrations();
        return _this;
    }
    /**
     * Repeater container
     * @returns {any}
     */
    EpsilonSectionRepeater.prototype.getRepeaterContainer = function () {
        return this.context.find('.repeater-sections');
    };
    /**
     * Load utilities
     * @public
     */
    EpsilonSectionRepeater.prototype.loadUtils = function () {
        return new repeater_section_utils_1.EpsilonRepeaterSectionUtils(this);
    };
    /**
     * Create existing rows
     * @public
     */
    EpsilonSectionRepeater.prototype.createExistingRows = function () {
        var control = this;
        if (this.control.params.value.length) {
            for (var i = 0; i < this.control.params.value.length; i++) {
                var row = void 0, addons = void 0;
                row = control.utils.add(control.control.params.value[i]);
                if (false !== row) {
                    addons = new repeater_addons_1.EpsilonRepeaterAddons(control, row);
                    addons.initPlugins();
                }
            }
        }
    };
    /**
     * Handle events
     * @public
     */
    EpsilonSectionRepeater.prototype.handleEvents = function () {
        var self = this;
        self.utils.addButton();
        /**
         * Addition of sections
         */
        jQuery('#sections-left-' + this.control.params.id).on('click', '.epsilon-section [data-action="add"]', function (e) {
            e.preventDefault();
            if (!self.limit || self.currentIndex < self.limit) {
                var row = void 0, addons = void 0;
                row = self.utils.add({ type: jQuery(this).parent().attr('data-id') });
                addons = new repeater_addons_1.EpsilonRepeaterAddons(self, row);
                addons.initPlugins();
                jQuery('body').removeClass('adding-section');
                jQuery('#sections-left-' + self.control.params.id).find('.available-sections').removeClass('opened');
                if (self.control.params['selective_refresh']) {
                    wp.customize.previewer.refresh();
                }
            }
            else {
                jQuery(self.control.selector + ' .limit').addClass('highlight');
            }
        });
        /**
         * Section description
         */
        jQuery('#sections-left-' + this.control.params.id).on('click', '.epsilon-section [data-action="info"]', function (e) {
            e.preventDefault();
            jQuery(this).parent().find('.epsilon-section-image-description').toggleClass('active');
            jQuery(this).parent().find('.epsilon-section-description').toggleClass('active');
        });
        /**
         * Section remove
         */
        this.context.on('click', '.repeater-row-remove', function (e) {
            self.handleRowDecrementor();
            if (!self.limit || self.currentIndex < self.limit) {
                jQuery(self.control.selector + ' .limit').removeClass('highlight');
            }
        });
    };
    /**
     *
     * @private
     */
    EpsilonSectionRepeater.prototype._handleNavigation = function () {
        var self = this;
        /**
         * Event that fires from the main page
         * so we can focus our panel and repeatable section
         */
        wp.customize.previewer.bind('epsilon-section-edit', function (data) {
            /**
             * In case the section does not exist, we can terminate
             */
            if ('undefined' === typeof (wp.customize.section(data.customizerSection))) {
                return;
            }
            /**
             * Iterate over the controls, minimize everything
             */
            _.each(self.rows, function (sect, index) {
                if (!sect.container.hasClass('minimized') && index !== data.section) {
                    self.utils.toggleMinimize(sect);
                }
            });
            wp.customize.section(data.customizerSection).focus();
            /**
             * Focus repeatable section
             */
            if (!_.isUndefined(self.rows[data.section]) && self.rows[data.section].container.hasClass('minimized')) {
                self.utils.toggleMinimize(self.rows[data.section]);
            }
        });
    };
    /**
     * Search functionality in the sections library
     *
     * @param selector
     */
    EpsilonSectionRepeater.prototype._initSearch = function () {
        var self = this;
        var selector = jQuery('#sections-left-' + self.control.params.id), input = selector.find('.sections-search-input'), val, collection, id;
        input.on('keyup change', _.debounce(function (e) {
            val = input.val();
            if ('undefined' !== typeof val) {
                val = val.toLowerCase();
            }
            collection = selector.find('.epsilon-section');
            jQuery.each(collection, function () {
                id = jQuery(this).attr('data-id');
                if ('undefined' !== typeof id) {
                    id = id.toLowerCase();
                }
                jQuery(this)[id.indexOf(val) !== -1 ? 'show' : 'hide']();
            });
        }, 1000));
    };
    /**
     * Handles the "tab" navigation in the available section list
     * @private
     */
    EpsilonSectionRepeater.prototype._handleIntegrations = function () {
        if (!this.control.params.integrations) {
            return;
        }
        jQuery('#sections-left-' + this.control.params.id).on('click', '.available-sections-tab-toggler', function (e) {
            var tab = jQuery(this).attr('data-tab');
            jQuery(this).siblings().removeClass('active');
            jQuery(this).addClass('active');
            e.preventDefault();
            if ('undefined' !== typeof tab) {
                jQuery('[data-tab-id="' + tab + '"]').siblings('div').removeClass('active').slideUp();
                jQuery('[data-tab-id="' + tab + '"]').slideDown().addClass('active');
            }
        });
    };
    /**
     * Move items "phisically"
     * @private
     */
    EpsilonSectionRepeater.prototype._moveElements = function () {
        jQuery('#sections-left-' + this.control.params.id).appendTo(jQuery('.wp-full-overlay'));
    };
    return EpsilonSectionRepeater;
}(repeater_1.EpsilonFieldRepeater));
exports.EpsilonSectionRepeater = EpsilonSectionRepeater;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var range_slider_1 = __webpack_require__(1);
/**
 * Espilon Typography Module
 */
var EpsilonTypography = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; params: {value: number; id: string}}} control
     */
    function EpsilonTypography(control) {
        this.control = control;
        this.context = jQuery(control.container);
        this.container = this.context.find('.epsilon-typography-container');
        this.selects = this.container.find('select');
        this.inputs = this.container.find('.epsilon-typography-input');
        this.sliders = this.container.find('.slider-container');
        this.id = control.params.id;
        this.init();
    }
    /**
     * Initiator
     */
    EpsilonTypography.prototype.init = function () {
        var self = this;
        var sliderSettings;
        /**
         * Instantiate the selectize javascript plugin
         * and the input type number
         */
        try {
            this._selectize = this.selects.selectize();
        }
        catch (err) {
            /**
             * In case the selectize plugin is not loaded, raise an error
             */
            console.warn('selectize not yet loaded');
        }
        /**
         * On clicking the advanced options toggler,
         */
        this.context.on('click', '.epsilon-typography-advanced > a', function (e) {
            var toggle = jQuery(this).attr('data-toggle');
            e.preventDefault();
            jQuery(this).toggleClass('active').parent().toggleClass('active');
            jQuery('#' + toggle).slideToggle().addClass('active');
        });
        /**
         * Great use of the EpsilonFramework, ahoy!
         */
        jQuery.each(this.sliders, function (index, element) {
            var sliderType = jQuery(element).attr('data-slider-type'), sliderSettings = {
                container: element,
                params: {
                    value: 0,
                    id: '',
                    sliderControls: {
                        min: 0,
                        max: 10,
                        step: 1
                    }
                }
            };
            switch (sliderType) {
                case 'letter-spacing':
                    sliderSettings.params.value = self.control.params.inputs['letter-spacing'];
                    sliderSettings.params.id = self.control.params.id + '-letter-spacing';
                    sliderSettings.params.sliderControls.min = 0;
                    sliderSettings.params.sliderControls.max = 5;
                    sliderSettings.params.sliderControls.step = 0.1;
                    break;
                case 'line-height':
                    sliderSettings.params.value = self.control.params.inputs['line-height'];
                    sliderSettings.params.id = self.control.params.id + '-line-height';
                    sliderSettings.params.sliderControls.min = 0;
                    sliderSettings.params.sliderControls.max = 40;
                    sliderSettings.params.sliderControls.step = 1;
                    break;
                default:
                    sliderSettings.params.value = self.control.params.inputs['font-size'];
                    sliderSettings.params.id = self.control.params.id + '-font-size';
                    sliderSettings.params.sliderControls.min = 0;
                    sliderSettings.params.sliderControls.max = 40;
                    sliderSettings.params.sliderControls.step = 1;
                    break;
            }
            new range_slider_1.EpsilonRangeSlider(sliderSettings);
        });
        this.handleEvents();
    };
    /**
     * Handle Events
     */
    EpsilonTypography.prototype.handleEvents = function () {
        var self = this;
        /**
         * On triggering the change event, create a json with the values and
         * send it to the preview window
         */
        this.inputs.on('change', function () {
            var val = self._parseJson();
            jQuery('#hidden_input_' + self.id).val(val).trigger('change');
        });
    };
    /**
     * Parse/create the json and send it to the preview window
     *
     * @param inputs
     * @param id
     * @private
     */
    EpsilonTypography.prototype._parseJson = function () {
        var self = this;
        var object = {
            action: 'epsilon_generate_typography_css',
            class: 'Epsilon_Typography',
            id: this.control.id,
            data: {
                selectors: this.control.params.selectors,
                stylesheet: this.control.params.stylesheet,
                id: this.control.id,
                json: {},
            }
        }, api = wp.customize;
        jQuery.each(this.inputs, function (index, value) {
            var key = jQuery(value).attr('id'), replace = self.id + '-', type = jQuery(this).attr('type');
            key = key.replace(replace, '');
            if ('checkbox' === type) {
                object.data.json[key] = jQuery(this).prop('checked') ? jQuery(value).val() : '';
            }
            else {
                object.data.json[key] = jQuery(value).val();
            }
        });
        api.previewer.send('update-inline-typography-css', object);
        return JSON.stringify(object.data);
    };
    return EpsilonTypography;
}());
exports.EpsilonTypography = EpsilonTypography;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Controls
 */
__webpack_require__(18);
__webpack_require__(15);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(12);
__webpack_require__(14);
__webpack_require__(16);
__webpack_require__(23);
__webpack_require__(13);
__webpack_require__(24);
__webpack_require__(17);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(11);
/**
 * Panels
 */
__webpack_require__(25);
/**
 * Sections
 */
__webpack_require__(27);
__webpack_require__(28);
__webpack_require__(26);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = __webpack_require__(0);
var EpsilonSectionRecommended = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{section: JQuery; params: { id: string}}} control
     */
    function EpsilonSectionRecommended(section) {
        /**
         * AJAXING =)
         * @type {boolean}
         */
        this.ajax = false;
        this.section = section;
        this.context = this.section.container;
        this.actions = this.section.params.actions.length;
        this.handleDismissals();
        this.handleEvents();
    }
    EpsilonSectionRecommended.prototype.handleDismissals = function () {
        this._dismissPlugin();
        this._dismissAction();
    };
    /**
     * Handle Events
     */
    EpsilonSectionRecommended.prototype.handleEvents = function () {
        this.context.on('click', '.epsilon-close-recommended-section', function (e) {
            e.preventDefault();
            jQuery(this).find('span').toggleClass('dashicons-arrow-down-alt2');
            jQuery('.recommended-actions_container').slideToggle(200);
        });
        jQuery(document).on('epsilon-plugin-activated', function (event, data) {
            var container = jQuery('span#' + data.plugin).parents('.epsilon-recommended-plugins'), next = container.next();
            container.fadeOut('200', function () {
                next.css({ opacity: 1, height: 'initial' }).fadeIn('200');
            });
        });
    };
    /**
     * Dismiss Plugin
     * @private
     */
    EpsilonSectionRecommended.prototype._dismissPlugin = function () {
        var section = this;
        var trigger = this.context.find('.epsilon-recommended-plugin-button');
        trigger.on('click', function (e) {
            var self = jQuery(this);
            /**
             * Get the container
             * @type {JQuery}
             */
            var container = self.parents('.epsilon-recommended-actions-container'), 
            /**
             * Get the next element ( this will be shown next )
             */
            next = container.next(), 
            /**
             * Get the title
             *
             * @type {JQuery}
             */
            title = container.parents('.control-section-epsilon-section-recommended-actions').find('h3'), 
            /**
             * Create the args object for the AJAX call
             *
             * action [ Class, Method Name ]
             * args [ parameters to be sent to method ]
             *
             * @type {{action: [*], args: {id: *, option: *}}}
             */
            args = {
                action: ['Epsilon_Notify_System', 'dismiss_required_action'],
                nonce: EpsilonWPUrls.ajax_nonce,
                args: {
                    id: jQuery(this).attr('id'),
                    option: jQuery(this).attr('data-option')
                }
            }, Ajax, replace, replaceText;
            if (section.ajax) {
                return;
            }
            section.ajax = true;
            Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(args);
            Ajax.request();
            jQuery(Ajax).on('epsilon-received-success', function (e) {
                section.ajax = false;
                if (Ajax.result && 'ok' === Ajax.result.message) {
                    /**
                     * Fade the current element and show the next one.
                     * We don't need to remove it at this time. Leave it to for
                     * server side
                     */
                    container.fadeOut('200', function () {
                        if (next.is('p')) {
                            replace = title.find('.section-title');
                            replaceText = replace.attr('data-social');
                            replace.text(replaceText);
                        }
                        next.css({ opacity: 1, height: 'initial' }).fadeIn('200');
                    });
                }
            });
        });
    };
    /**
     * Dismiss Action
     * @private
     */
    EpsilonSectionRecommended.prototype._dismissAction = function () {
        var section = this;
        var trigger = this.context.find('.epsilon-dismiss-required-action');
        trigger.on('click', function (e) {
            var self = jQuery(this);
            /**
             * Get the container
             * @type {JQuery}
             */
            var container = self.parents('.epsilon-recommended-actions-container'), 
            /**
             * Get the title
             *
             * @type {JQuery}
             */
            title = container.parents('.control-section-epsilon-section-recommended-actions').find('h3'), 
            /**
             * Get the indew from the notice
             *
             * @type {JQuery}
             */
            notice = title.find('.epsilon-actions-count > .current-index'), 
            /**
             * Get the next element ( this will be shown next )
             */
            next = container.next(), 
            /**
             * Create the args object for the AJAX call
             *
             * action [ Class, Method Name ]
             * args [ parameters to be sent to method ]
             *
             * @type {{action: [*], args: {id: *, option: *}}}
             */
            args = {
                action: ['Epsilon_Notify_System', 'dismiss_required_action'],
                nonce: EpsilonWPUrls.ajax_nonce,
                args: {
                    id: jQuery(this).attr('id'),
                    option: jQuery(this).attr('data-option')
                }
            }, replace, plugins, replaceText, 
            /**
             * Get the total
             *
             * @type {Number}
             */
            total = notice.attr('data-total'), 
            /**
             * Get the current index
             *
             * @type {Number}
             */
            index = container.attr('data-index'), Ajax;
            if ('undefined' !== total) {
                total = parseInt(total);
            }
            if ('undefined' !== index) {
                index = parseInt(index);
            }
            if (section.ajax) {
                return;
            }
            section.ajax = true;
            Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(args);
            Ajax.request();
            jQuery(Ajax).on('epsilon-received-success', function (e) {
                section.ajax = false;
                if (Ajax.result && 'ok' === Ajax.result.message) {
                    /**
                     * If it's the last element, show plugins
                     */
                    if (total <= index) {
                        replace = title.find('.section-title');
                        plugins = jQuery('.epsilon-recommended-plugins');
                        replaceText = replace.attr('data-social');
                        if (plugins.length) {
                            replaceText = replace.attr('data-plugin_text');
                        }
                        title.find('.epsilon-actions-count').remove();
                        replace.text(replaceText);
                    }
                    else {
                        notice.text(index + 1);
                    }
                    /**
                     * Fade the current element and show the next one.
                     * We don't need to remove it at this time. Leave it to for
                     * server side
                     */
                    container.fadeOut('200', function () {
                        next.css({ opacity: 1, height: 'initial' }).fadeIn('200');
                    });
                }
            });
        });
    };
    return EpsilonSectionRecommended;
}());
exports.EpsilonSectionRecommended = EpsilonSectionRecommended;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EpsilonSectionDoubled = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{section: JQuery; params: { id: string}}} control
     */
    function EpsilonSectionDoubled(section) {
        /**
         * save instance of section
         */
        this.section = section;
        /**
         * Move out of the ugly list, this has overflow hidden and we can`t display it properly
         */
        this.createParent();
        /**
         * Append new sections to parent
         */
        this.section.container.appendTo(this.parent);
        /**
         * Handle Events
         */
        this.handleEvents();
    }
    EpsilonSectionDoubled.prototype.handleEvents = function () {
        var self = this;
        var section = this.section;
        /**
         * Close sections
         */
        section.container.on('click', '.epsilon-close-doubled-section', function (e) {
            e.preventDefault();
            jQuery('body').removeClass('adding-doubled-section');
            jQuery('body').find('.doubled-section-opened').removeClass('doubled-section-opened');
        });
        /**
         * Open sections
         */
        section.headContainer.on('click', function (e) {
            var opened, strippedIdHead, strippedIdContainer;
            e.preventDefault();
            /**
             * We need to close everything on click
             * @type {*|{}}
             */
            opened = self.parent.find('.doubled-section-opened');
            if (opened.length) {
                opened.removeClass('doubled-section-opened');
            }
            if (jQuery('body').hasClass('adding-doubled-section')) {
                strippedIdHead = jQuery(this).attr('id');
                if ('undefined' !== typeof strippedIdHead) {
                    strippedIdHead = strippedIdHead.replace('accordion-section-', '');
                }
                strippedIdContainer = opened.attr('id');
                if ('undefined' !== typeof strippedIdContainer) {
                    strippedIdContainer = strippedIdContainer.replace('sub-accordion-section-', '');
                }
                if (strippedIdContainer === strippedIdHead) {
                    jQuery('body').removeClass('adding-doubled-section');
                }
            }
            else {
                jQuery('body').addClass('adding-doubled-section');
            }
            jQuery.each(section.container, function () {
                if (jQuery(this).is('li')) {
                    return;
                }
                jQuery(this).addClass('doubled-section-opened');
            });
        });
    };
    /**
     * Create a parent container
     */
    EpsilonSectionDoubled.prototype.createParent = function () {
        var parent = jQuery('.wp-full-overlay').find('.doubled-section-parent');
        if (!parent.length) {
            jQuery('.wp-full-overlay').append('<div class="doubled-section-parent"></div>');
            parent = jQuery('.wp-full-overlay').find('.doubled-section-parent');
            this.parent = parent;
        }
        this.parent = parent;
    };
    return EpsilonSectionDoubled;
}());
exports.EpsilonSectionDoubled = EpsilonSectionDoubled;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// epsilon-framework-customizer.js